import _extends from 'babel-runtime/helpers/extends';

import { testStatus } from '@/common/material-metadata';

export default {
  name: 'TestStatusSelector',

  componentName: 'TestStatusSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        placeholder: '请选择测试状态',
        clearable: true,
        disabled: false,
        options: testStatus.filter(function (item) {
          return item.value !== 3 && item.value !== 11;
        })
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};